// Generated types for ProductExtractionTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { EntityExtractionTaskReadAPI, EntityExtractionTaskWriteAPI } from './entityextractiontask';
import { EntityExtractionTaskReadAPISchemaObject, EntityExtractionTaskWriteAPISchemaObject } from './entityextractiontask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ProductExtractionTaskReadAPI extends EntityExtractionTaskReadAPI {
}

export interface ProductExtractionTaskWriteAPI extends EntityExtractionTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ProductExtractionTaskReadAPISchema: z.ZodType<ProductExtractionTaskReadAPI> = EntityExtractionTaskReadAPISchemaObject.extend({}).passthrough();

export const ProductExtractionTaskWriteAPISchema: z.ZodType<ProductExtractionTaskWriteAPI> = EntityExtractionTaskWriteAPISchemaObject.extend({}).passthrough();
